const gr = require("mxgraph-js");

export default class StyleGraph {
  private _graph: any;

  constructor (graph: any) {
    this._graph = graph
  }

  defaultStyle = () => {

    let style = this._graph.getStylesheet().getDefaultVertexStyle();      
    style[gr.mxConstants.STYLE_SHAPE] = 'label';
    style[gr.mxConstants.STYLE_FILLCOLOR] = '#84A1AA'
    style[gr.mxConstants.STYLE_INDICATOR_WIDTH] = 90;
    style[gr.mxConstants.STYLE_INDICATOR_HEIGHT] = 90;
    style[gr.mxConstants.STYLE_INDICATOR_COLOR] = '#84A1AA';
    delete style[gr.mxConstants.STYLE_STROKECOLOR]; // transparent
    delete style[gr.mxConstants.STYLE_FILLCOLOR]; // transparent      
    
    style = this._graph.getStylesheet().getDefaultEdgeStyle();
    style[gr.mxConstants.STYLE_EDGE] = gr.mxEdgeStyle.ElbowConnector;
    // style[gr.mxConstants.STYLE_ELBOW] = gr.mxConstants.ELBOW_VERTICAL;
    style[gr.mxConstants.STYLE_ROUNDED] = true;
    style[gr.mxConstants.STYLE_STROKECOLOR] = '#84A1AA';
    style[gr.mxConstants.STYLE_LABEL_BACKGROUNDCOLOR] = 'white';
    style[gr.mxConstants.STYLE_ORTHOGONAL] = false;
    style[gr.mxConstants.STYLE_STARTARROW] = gr.mxConstants.ARROW_OVAL;
    style[gr.mxConstants.STYLE_ENDARROW] = gr.mxConstants.ARROW_BLOCK; 
    style[gr.mxConstants.STYLE_SHAPE] = gr.mxConstants.SHAPE_CONNECTOR;
    style[gr.mxConstants.STYLE_ALIGN] = gr.mxConstants.ALIGN_CENTER;
    style[gr.mxConstants.STYLE_VERTICAL_ALIGN] = gr.mxConstants.ALIGN_MIDDLE;
    style[gr.mxConstants.STYLE_SOURCE_PERIMETER_SPACING] = 4
    
    this._graph.setEnabled(false)
  }

  setLayout = (parent: any) => {
    const layout = new gr.mxHierarchicalLayout(this._graph, 'north');
    layout.edgeStyle=4;
    layout.intraCellSpacing=60;
    layout.interRankCellSpacing=60;
    const morph = new gr.mxMorphing(this._graph);
    const graph = this._graph;
    morph.addListener(gr.mxEvent.DONE, function()
    {
      graph.getModel().endUpdate();
    }); 
    
    layout.execute(parent);

    return layout;
  }


}